import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export function CategoryCards() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
          探索韩国伦理的多元维度
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          从儒家思想的深远影响，到现代社会的道德演变，我们的分类体系帮您系统理解韩国伦理全貌
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 border border-background-200 rounded-lg p-6 md:p-7 hover:border-accent-300 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors duration-200">
              {cat.name}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              {cat.description}
            </p>
            <span className="text-xs text-foreground-500 flex items-center gap-1">
              <i className="ri-article-line"></i>
              {cat.articleCount} 篇文章
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}